import { Button, Result } from 'antd';

const NotFound = () => (
  <Result
    icon={<img style={{ maxWidth: 350 }} src="/assets/not-found.png" alt="404" />}
    title="404"
    subTitle="Lo siento, la página que visitaste no existe."
    extra={<Button type="primary">Home</Button>}
  />
);

export default NotFound;
